import { type JobylonEmbedConfig } from "@/app/(site)/_components/SanityBlocks/JobylonBlock/types"

export function buildJobylonEmbedUrl(
    config: JobylonEmbedConfig,
    targetId: string
): string {
    const params = new URLSearchParams()
    params.set("companyId", String(config.companyId))
    params.set("target", targetId)
    params.set("page_size", String(config.pageSize))

    if (config.filters) {
        for (const [key, value] of Object.entries(config.filters)) {
            if (value === undefined || value === null) {
                continue
            }

            if (Array.isArray(value)) {
                params.set(key, value.join(","))
                continue
            }

            params.set(key, String(value))
        }
    }

    return `/api/jobylon/embed?${params.toString()}`
}
